export const home = "/home";
export const createIngredientExit = "/newIngredientExit";
export const error = "/error";
export const fallback = "*";
export const addNewMember = "/add-member";


export const login = "/login";
export const verificationCode = "/verificationcode/:email";
export const emailVerification = "/email-verification";
export const changePassword = "/reset-password";
export const profile = "/profile";
export const notifications = "/notifications";


// Admin Routes
export const users = "/users";
export const categories = "/categories";
export const regions = "/regions"

// Active exit requests
export const activeReqs = "/active-requests";
export const reqInfo = activeReqs + "/req-info/:reqId";

// My active exit requests
export const myActiveReqs = "/my-active-requests";
export const myReqInfo = "/my-req-info/:reqId";
export const createFromMyRequests = myActiveReqs + "/new"; // Route for creating from my requests page
export const editExitRequest = myActiveReqs + "/edit/:reqId"; // New route for editing from my requests page

// Canceled exit requests
export const canceledReqs = "/canceled-requests";
export const canceledReqInfo = canceledReqs + "/req-info/:reqId";

// My canceled exit requests
export const myCanceledReqs = "/my-canceled-requests";
export const myCanceledReqInfo = myCanceledReqs + "/my-req-info/:reqId";

// R&D Member Routes
export const rdIncomingRequests = "/rd-incoming-requests";
export const rdRequestInfoFromIncomingRequests = rdIncomingRequests + "/request/:reqId/:categoryAssignmentId";
export const rdRequestResponseFromIncomingRequests = rdIncomingRequests + "/response/:reqId/:categoryAssignmentId";
export const rdRespondedRequestInfoFromIncomingRequests = rdIncomingRequests + "/responseInfo/:reqId/:categoryAssignmentId";


export const rdResponses = "/rd-responses";
export const rdRequestResponseFromResponses = rdResponses + "/response/:reqId/:categoryAssignmentId";
export const rdRespondedRequestInfoFromResponses = rdResponses + "/responseInfo/:reqId";


export const regDelegationRequests = "/regulatory-delegation-requests";
export const regExtensionRequests = "/regulatory-extension-requests";
export const extensionRequestDetail = "/extension-request-detail/:extensionRequestId";
export const rdDelegationRequests =  "/rd-delegation-requests";
export const rdExtensionRequests = "/rd-extension-requests";
export const delegateRequestDetail= "/delegate-request-detail/:delegateId";
// Modified Exit Plan routes to follow the same pattern
export const rdExitPlans = "/rd-exit-plans";
// Use a consistent URL structure for both viewing and editing
export const rdExitPlanInfo = "/rd-exit-plan/:planId";
export const rdExitPlanEdit = "/rd-exit-plan/edit/:planId";
export const rdExitPlanCreate = rdExitPlans + "/create/:reqId/:categoryAssignmentId";
export const ViewExitPlan = "/view/:responseId";


// Approver Routes (formerly Manager)
export const PendingApprovals = "/pending-approvals";
export const AssignedRequests = "/assigned-requests";
export const AllExitRequests = "/all-exit-requests";
export const ApproverRequestInfo = "/request-info/:reqId";
export const ApproverEscalatedRequests = "/escalated-requests";
export const ApproverEscalatedRequestResponse = "/escalated-requests/response/:reqId/:categoryAssignmentId";
export const ApproverEscalatedRequestInfo = "/escalated-requests/request/:reqId/:categoryAssignmentId";
export const ApproverExitPlanCreate = "/escalated-exit-plans/create/:reqId/:categoryAssignmentId";
export const ApproverExitPlanInfo = "/escalated-exit-plan/:planId";
export const ApproverExitPlanEdit = "/escalated-exit-plan/edit/:planId";
export const ApproverPlansToApprove = "/plans-to-approve";

// RD-Manager Routes (same as R&D + manager capabilities)
export const rdManagerIncomingRequests = "/rdm-incoming-requests";
export const rdManagerRequestInfoFromIncomingRequests = rdManagerIncomingRequests + "/request/:reqId/:categoryAssignmentId";
export const rdManagerRequestResponseFromIncomingRequests = rdManagerIncomingRequests + "/response/:reqId/:categoryAssignmentId";
export const rdManagerResponses = "/rdm-responses";
export const rdManagerRequestResponseFromResponses = rdManagerResponses + "/response/:reqId/:categoryAssignmentId";
export const rdManagerExitPlans = "/rdm-exit-plans";
export const rdManagerExitPlanInfo = "/rdm-exit-plan/:planId";
export const rdManagerExitPlanEdit = "/rdm-exit-plan/edit/:planId";
export const rdManagerExitPlanCreate = rdManagerExitPlans + "/create/:reqId/:categoryAssignmentId";
export const rdManagerDelegationRequests = "/rdm-delegation-requests";

// Exemption Requests (an exit plan of type EXEMPTION_REQUEST)
// One shared detail page, registered in every role block that can see exemptions.
export const exemptionInfo = "/exemption/:planId";
export const rdExemptions = "/rd-exemptions";
export const rdExemptionCreate = rdExemptions + "/create/:reqId/:categoryAssignmentId";
export const rdManagerExemptions = "/rdm-exemptions";
export const rdManagerExemptionCreate = rdManagerExemptions + "/create/:reqId/:categoryAssignmentId";
export const regulatoryExemptions = "/regulatory-exemptions";
export const ApproverExemptionsToApprove = "/exemptions-to-approve";
export const ApproverExemptionsHub = "/regulatory-exemptions-hub";
export const ApproverExemptionCreate = "/escalated-exemptions/create/:reqId/:categoryAssignmentId";

// Support Provider Routes
export const supportProviderHome = "/support-provider-home";
export const supportProviderAssignedRequests = "/support-assigned-requests";
export const supportProviderAllRequests = "/support-all-requests";
export const supportProviderRequestsHub = "/support-requests-hub";
export const supportRequestDetail = "/support-request/:requestId";

// R&D Coordinator Routes (same structure as R&D but separate URL prefix)
export const rdCoordinatorIncomingRequests = "/coordinator-incoming-requests";
export const rdCoordinatorRequestInfo = rdCoordinatorIncomingRequests + "/request/:reqId/:categoryAssignmentId";
export const rdCoordinatorResponsePage = rdCoordinatorIncomingRequests + "/response/:reqId/:categoryAssignmentId";
export const rdCoordinatorResponses = "/coordinator-responses";
export const rdCoordinatorResponseFromResponses = rdCoordinatorResponses + "/response/:reqId/:categoryAssignmentId";
